import React, { useState } from "react";
import "./FAQSection.css";

const faqs = [
  {
    q: "What will I learn in this course?",
    a: "You'll get the core frameworks and playbooks that power viral hits—without spoon-feeding every secret. We cover the essential strategies for niche selection, competitive analysis, crafting hooks, structuring, filming, and editing. From there, success hinges on your own creativity and execution.",
  },
  {
    q: "What equipment do I need?",
    a: "All you need is a smartphone. We show you how to film, light, and edit pro-level clips using just your phone and free or low-cost apps.",
  },
  {
    q: "How long does it take to complete?",
    a: "You can work through all 7 steps in just 2–3 days. To lock in real results, though, you must practice each lesson and apply it immediately to your own content.",
  },
  {
    q: "Do these tactics work on other platforms?",
    a: "Yes—every principle in this course applies to all short-form video platforms (TikTok, Reels, Shorts, etc.). The formats and algorithms differ slightly, but the viral mechanics stay the same.",
  },
  {
    q: "What will I be able to do after finishing?",
    a: "You'll have everything you need to plan, film, and edit viral-ready videos in any niche. With the frameworks in hand and a bit of practice, you'll confidently launch content that grabs attention and drives shares.",
  },
  {
    q: "Can't I learn this on YouTube?",
    a: "You'll find plenty of free tutorials—but none backed by the level of hands-on testing and real-world success we deliver. We've produced and analyzed thousands of videos across diverse niches, generating over 2 billion views in the process. Our data-driven frameworks come straight from what actually works, not just theory.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  const toggle = (idx: number) => setOpen(open === idx ? null : idx);

  return (
    <section className="faq-section">
      <div className="faq-heading">
        FAQ’s
      </div>
      <div className="faq-list">
        {faqs.map((item, idx) => (
          <div className={`faq-card${open === idx ? " open" : ""}`} key={idx}>
            <button
              className="faq-question"
              onClick={() => toggle(idx)}
              aria-expanded={open === idx}
              aria-controls={`faq-answer-${idx}`}
            >
              <span>{item.q}</span>
              <span className={`faq-icon${open === idx ? " open" : ""}`} aria-hidden="true">
                +
              </span>
            </button>
            <div
              id={`faq-answer-${idx}`}
              role="region"
              className={`faq-answer-wrapper${open === idx ? " open" : ""}`}
              style={{
                maxHeight: open === idx ? "200px" : "0",
              }}
            >
              <div className="faq-answer-content">
                <div className="faq-answer">{item.a}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
} 